import IndexDBAdapter from "./IndexDBHelper";

let adapter = IndexDBAdapter;

export function setDBAdapter(newAdapter) {
  adapter = newAdapter;
}

export const db = {
  add: (collection, data) => adapter.add(collection, data),
  update: (collection, id, data) => adapter.update(collection, id, data),
  delete: (collection, id) => adapter.delete(collection, id),
  clear: (collection) => adapter.clear(collection),
  get: (collection, id) => adapter.get(collection, id),
  getAll: (collection) => adapter.getAll(collection),
  addAll: (collection, list) => adapter.addAll(collection, list),
  filter: (collection, query) => adapter.filter(collection, query),
  runTransaction: (storeNames, callback, mode, context) => adapter.runTransaction(storeNames, callback, mode, context),
};
